import React, { useEffect, useState } from 'react';
import styles from './Speaker.module.scss';
import { UI_Icon } from '../Media/Icon/Icon';
import Speaker from 'ui/icons/icon_speaker.svg';
import classNames from 'classnames';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';

declare global {
	interface MarthaType {
		click?: (e?: Event) => void;
	}

	interface Window {
		martha?: MarthaType;
	}
}

export interface SpeakerProps {
	speakerAloudText?: string;
	background?: 'Primary';
	noBottomSpacing?: boolean;
}

export const UI_Speaker: React.FC<SpeakerProps> = ({ speakerAloudText, background, noBottomSpacing }) => {
	const [enabled, setEnabled] = useState(false);

	useEffect(() => {
		setEnabled(!!window.martha && typeof window.martha.click === 'function');
	}, []);

	return (
		<CludoComment>
			<div
				className={classNames(styles.Speaker, {
					[styles[`Speaker___background${background}`]]: background,
					[styles.Speaker___noBottomSpacing]: noBottomSpacing,
				})}
			>
				<UI_Container width="Standard">
					<a
						className={styles.Speaker_button}
						data-martha-select=".martha-read"
						onClick={(e) => {
							e.preventDefault();
							if (window.martha && typeof window.martha.click === 'function') {
								window.martha.click.call(e.currentTarget, e);
							}
						}}
						tabIndex={enabled ? 0 : -1}
						aria-disabled={!enabled}
					>
						<span>{speakerAloudText}</span>
						<UI_Icon size="md" className={styles.Speaker_icon}>
							<Speaker />
						</UI_Icon>
					</a>
				</UI_Container>
			</div>
		</CludoComment>
	);
};
